/**
 * Caricamento e piccoli aiuti delle viste: dati con ricarica dopo ogni
 * modifica, errori dei form, date.
 */

import { useCallback, useEffect, useState } from 'react';
import { ErroreApi, chiama } from '../api/client.js';

/**
 * Con `tieni` i dati del percorso precedente restano a schermo finché
 * arrivano i nuovi: serve ai filtri della stessa vista, dove svuotare la
 * pagina la accorcerebbe e la farebbe risalire.
 */
export function useDati<T>(percorso: string, { tieni = false } = {}) {
  const [dati, setDati] = useState<T | null>(null);
  const [errore, setErrore] = useState<string | null>(null);
  const [stato, setStato] = useState<number | null>(null);

  const ricarica = useCallback(async () => {
    if (!percorso) {
      setDati(null);
      setErrore(null);
      setStato(null);
      return;
    }
    try {
      setDati(await chiama<T>(percorso));
      setErrore(null);
      setStato(null);
    } catch (e) {
      setStato(e instanceof ErroreApi ? e.stato : null);
      setErrore(e instanceof Error ? e.message : 'Dati non disponibili.');
    }
  }, [percorso]);

  useEffect(() => {
    // Cambiando percorso, per esempio squadra dal selettore, i dati del
    // precedente non devono restare a schermo mentre arrivano i nuovi.
    if (!tieni) {
      setDati(null);
      setErrore(null);
      setStato(null);
    }
    void ricarica();
  }, [ricarica, tieni]);

  return { dati, errore, stato, ricarica };
}

/** Primo messaggio per campo: il form ne mostra uno solo sotto ciascun campo. */
export function erroriPerCampo(errore: {
  issues: { path: (string | number)[]; message: string }[];
}): Record<string, string> {
  const esito: Record<string, string> = {};
  for (const issue of errore.issues) {
    const campo = String(issue.path[0] ?? '');
    esito[campo] ??= issue.message;
  }
  return esito;
}

export const messaggio = (e: unknown): string =>
  e instanceof Error ? e.message : 'Operazione non riuscita.';

/** "2026-07-01" -> "01/07/2026", senza passare da Date e dai suoi fusi. */
export const dataBreve = (iso: string): string => iso.split('-').reverse().join('/');
